import { QBoxDataPair } from "../CoreApp/QBoxDataPair";

export function CreateBoxPair(scNode) {
  // , inTopSC)
  var newPair = new QBoxDataPair();
  var dbObj = scNode.GetDataObj();
  var l = scNode.GetLayout();

  newPair.InitFromObj(l, dbObj); // , inTopSC);

  return newPair;
}
